import { svgReferences } from '../../utils/svg/svg';

const SvgIcon = ({
  iconName,
  fill = '',
  stroke = '',
  height,
  width,
}: {
  iconName?: keyof typeof svgReferences;
  fill?: string;
  stroke?: string;
  height?: number;
  width?: number;
}) => {
  if (iconName) {
    const SvgComponent = svgReferences[iconName];

    if (SvgComponent)
      return (
        <SvgComponent
          data-testid={`${iconName}-svg-icon`}
          fill={fill}
          stroke={stroke}
          width={width}
          height={height}
        />
      );
  }

  return <p data-testid="svg-not-found-text">N/A</p>;
};

export default SvgIcon;
